import { CountryCode } from 'libphonenumber-js';
import { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchFromStorage } from 'utils/storage';
import strings from '../../../../common/Translation/Translate';
import axiosInstance from '../../../../utils/axios';
import { routes } from '../../../../utils/constants/routes';
import { URLS } from '../../../../utils/constants/urls';
import AddEdit from '../../CommonPage/AddEdit';
import { AddAgentsForm } from './AddAgentsForm';

const AddEditAgents: FC = () => {
  const { id } = useParams() as any;
  const defaultCountry = (fetchFromStorage('defaultCountryCode') || 'IN') as CountryCode;
  const [pageResponse, setPageResponse] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getInitialResponse = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(URLS.editAgent(id));
      setPageResponse(data);
    } catch (error: any) { }
    finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    (async () => {
      if (id) {
        await getInitialResponse();
      }
    })();
  }, [getInitialResponse, id]);

  const handleCustomResponse = (custom: any) => {
    const body = {
      ...custom,
      phone:
        custom.phone === ''
          ? {
            countryCode: null,
            value: '',
          }
          : custom.phone,
    };

    return body;
  };

  const pageConfig = {
    title: id ? strings.source_title_edit : strings.source_title_add,
    successMessage: id ? strings.common_update_message : strings.common_save_message,
    addEditApiUrl: id ? URLS.editAgent(id) : URLS.addAgent,
    initialApi: URLS.editAgent(id),
    formModel: AddAgentsForm(strings, defaultCountry),
    navigateToPage: routes.agentList,
    isCustomResponse: true,
  };

  return <AddEdit pageConfig={pageConfig} pageResponse={pageResponse} handleCustomResponse={handleCustomResponse} pageLoading={loading} />;
};
export default AddEditAgents;
